import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import PersianDate from "persian-date";
import { useState } from "react";

const ChartExport = ({ data, fileName = "data", title = "خروجی اکسل", btnClassName = ""  }) => {
  const [exportLoader, setExportLoader] = useState(false);

  const buildTable = () => {
    if (!data || !data.length) return [];

    const allSeries = [];
    data.forEach((group) => {
      group.forEach((series) => allSeries.push(series));
    });

    // جمع کردن همه timestampها
    const allTimestampsSet = new Set();
    allSeries.forEach((series) => {
      series.data.forEach(([ts]) => allTimestampsSet.add(ts));
    });
    const allTimestamps = Array.from(allTimestampsSet).sort((a, b) => a - b);

    const tableData = [];

    allTimestamps.forEach((ts) => {
      // پیدا کردن حداکثر تعداد داده در این timestamp برای هر سری
      const seriesValues = {};
      let maxValuesCount = 1;

      allSeries.forEach((series) => {
        const values = [];
        for (let i = 0; i < series.data.length; i++) {
          if (series.data[i][0] === ts) {
            values.push(series.data[i][1]);
          }
        }
        seriesValues[`${series.name} ${series.chartName}`] = values;
        maxValuesCount = Math.max(maxValuesCount, values.length);
      });

      const tsInMs = ts > 10000000000 ? ts : ts * 1000;
      const dateStr = new PersianDate(tsInMs)
        .toCalendar("persian")
        .utc()
        .toLocale("en")
        .format("YYYY/MM/DD HH:mm:ss");

      // برای هر ردیف (به تعداد maxValuesCount) یک ردیف بساز
      for (let rowIndex = 0; rowIndex < maxValuesCount; rowIndex++) {
        const row = {
          تاریخ: dateStr,
        };

        allSeries.forEach((series) => {
          const key = `${series.name} ${series.chartName}`;
          const values = seriesValues[key];
          row[key] =
            values && values.length > rowIndex ? values[rowIndex] : null;
        });

        tableData.push(row);
      }
    });

    return tableData;
  };

  const handleExport = () => {
    setExportLoader(true);

    try {
      const tableData = buildTable();
      if (!tableData.length) {
        setExportLoader(false);
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      for (let row = range.s.r; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          const cell = worksheet[cellAddress];
          if (!cell) continue;

          const isHeader = row === 0;

          cell.s = {
            font: {
              name: "Vazir",
              sz: 12,
              bold: isHeader,
              color: { rgb: "000000" },
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrapText: true,
            },
            // border: {
            //   top: { style: "thin" },
            //   bottom: { style: "thin" },
            //   left: { style: "thin" },
            //   right: { style: "thin" },
            // },
          };
        }
      }

      // Auto column width
      const colWidths = [];
      for (let col = range.s.c; col <= range.e.c; col++) {
        let maxLength = 0;
        for (let row = range.s.r; row <= range.e.r; row++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          const cell = worksheet[cellAddress];
          if (!cell || !cell.v) continue;
          const cellValue = cell.v.toString();
          maxLength = Math.max(maxLength, Math.min(cellValue.length + 5, 50));
        }
        colWidths.push({ wch: Math.min(Math.max(maxLength, 10), 60) });
      }
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${fileName}.xlsx`);
    } catch (error) {
      console.error("Error exporting Excel:", error);
    } finally {
      setExportLoader(false);
    }
  };

  return (
    <button
      type="button"
      className={btnClassName || "btn btn-success-app mx-3"}
      onClick={handleExport}
      disabled={exportLoader}
    >
      {exportLoader ? (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      ) : (
        <span>{title}</span>
      )}
    </button>
  );
};

export default ChartExport;
